import { lazy, Suspense, type ReactElement } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { AppShell } from './components/AppShell';
import { DashboardPage } from './pages/DashboardPage';
import { InboxPage } from './pages/InboxPage';
import { LoginPage } from './pages/LoginPage';
import { TrocarSenhaPage } from './pages/TrocarSenhaPage';
import { useAuth } from './lib/auth';

const AdminApp = lazy(() => import('./admin/AdminApp'));
// O painel e o inbox ficam no pacote inicial porque sao onde a atendente entra. O resto
// carrega na primeira visita: o detalhe do cliente sozinho traz o recharts.
const AgendaPage = lazy(() =>
  import('./pages/AgendaPage').then((m) => ({ default: m.AgendaPage })),
);
const ClientDetailPage = lazy(() =>
  import('./pages/ClientDetailPage').then((m) => ({ default: m.ClientDetailPage })),
);
const ClientsPage = lazy(() =>
  import('./pages/ClientsPage').then((m) => ({ default: m.ClientsPage })),
);
const ConectarPage = lazy(() =>
  import('./pages/ConectarPage').then((m) => ({ default: m.ConectarPage })),
);
const ConfiguracoesPage = lazy(() =>
  import('./pages/ConfiguracoesPage').then((m) => ({ default: m.ConfiguracoesPage })),
);
const EquipePage = lazy(() =>
  import('./pages/EquipePage').then((m) => ({ default: m.EquipePage })),
);
const VerificacaoPage = lazy(() =>
  import('./pages/VerificacaoPage').then((m) => ({ default: m.VerificacaoPage })),
);

function RequireAuth(): ReactElement {
  const { me } = useAuth();
  if (me === null) return <Navigate to="/login" replace />;
  if (me.mustChangePassword === true) return <Navigate to="/trocar-senha" replace />;
  return <AppShell />;
}

export function App(): ReactElement {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/trocar-senha" element={<TrocarSenhaPage />} />
      <Route
        path="/admin/*"
        element={
          <Suspense fallback={null}>
            <AdminApp />
          </Suspense>
        }
      />
      {/* Fora do `RequireAuth`: quem abre e o medico, que nao tem conta no Zenda. Quem
          autentica e o segredo da URL, conferido no servidor. */}
      <Route
        path="/conectar/:token"
        element={
          <Suspense fallback={null}>
            <ConectarPage />
          </Suspense>
        }
      />
      <Route element={<RequireAuth />}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/inbox" element={<InboxPage />} />
        <Route path="/clientes" element={<ClientsPage />} />
        <Route path="/clientes/:id" element={<ClientDetailPage />} />
        {/* A agenda pertence a um medico, e a URL carrega isso: sem o cliente na
            rota, "a agenda" seria a soma de varios, que e uma agenda que ninguem
            tem. Sem parametro a pagina e o seletor. */}
        <Route path="/agenda" element={<AgendaPage />} />
        <Route path="/agenda/:clientId" element={<AgendaPage />} />
        <Route path="/equipe" element={<EquipePage />} />
        <Route path="/configuracoes" element={<ConfiguracoesPage />} />
        {/* Fora do menu de proposito: e um instrumento para gravar os videos do
            App Review, nao uma tela de produto. Sai quando a aprovacao sair. */}
        <Route path="/verificacao" element={<VerificacaoPage />} />
        {/* A saude dos numeros deixou de ser uma tela propria: ela e um atributo do
            cliente, e e la que a atendente vai agir. */}
        <Route path="/canais" element={<Navigate to="/clientes" replace />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
